// extracted by mini-css-extract-plugin
module.exports = {"info":"style_info__fsb5z","destructive":"style_destructive__2xdW8","warning":"style_warning__5H8uB","hide-icon":"style_hide-icon__3Twrf"};